import React from 'react';
import { Container } from 'react-bootstrap';

const DpaPage = () => {
  return (
    <Container className="my-4">
      <h1>Acuerdo de Procesamiento de Datos (DPA)</h1>
      <p className="text-muted">Última actualización: 17 de octubre de 2026</p>

      <h2 className="mt-4">1. PARTES Y ROLES</h2>
      <p>Este acuerdo se celebra entre las siguientes partes:</p>
      <p>
        <strong>EL CONTROLADOR (Responsable):</strong> El Cliente (el negocio que usa Evazard), quien decide qué datos recolectar de sus consumidores finales y es el propietario de dichos datos.
      </p>
      <p>
        <strong>EL PROCESADOR (Encargado):</strong> Jesús Antonio Castañeda Valencia, actuando bajo la marca comercial CValenciaIT, propietario de la plataforma Evazard.
      </p>
      <div>
        <strong>Razón Social:</strong> Jesús Antonio Castañeda Valencia<br />
        <strong>Marca Comercial:</strong> CValenciaIT<br />
        <strong>Plataforma:</strong> Evazard<br />
      </div>

      <h2 className="mt-4">2. OBJETO</h2>
      <p>
        El Procesador se compromete a tratar los datos personales de terceros (clientes finales, proveedores del Cliente, etc.) cargados en la plataforma Evazard, única y exclusivamente para la prestación del servicio de software contratado y según las instrucciones del Controlador.
      </p>

      <h2 className="mt-4">3. OBLIGACIONES DEL PROCESADOR</h2>
      <ul>
        <li><strong>a) No uso propio:</strong> No utilizará los datos de los clientes finales para fines propios, marketing, minería de datos o venta a terceros.</li>
        <li><strong>b) Seguridad:</strong> Implementará medidas técnicas y organizativas razonables para proteger los datos contra acceso no autorizado, pérdida o destrucción.</li>
        <li><strong>c) Confidencialidad:</strong> Garantizará que cualquier persona autorizada para procesar los datos (empleados o colaboradores) se haya comprometido a respetar la confidencialidad.</li>
        <li><strong>d) Sub-procesadores:</strong> El Controlador autoriza al Procesador a contratar servicios de infraestructura de terceros (como proveedores de hosting, ej: AWS, DigitalOcean, bases de datos) que son necesarios para el funcionamiento de Evazard. El Procesador se asegurará de que estos sub-procesadores cumplan con obligaciones de protección de datos equivalentes.</li>
      </ul>

      <h2 className="mt-4">4. NOTIFICACIÓN DE BRECHAS DE SEGURIDAD</h2>
      <p>
        En caso de ocurrir una violación de seguridad que comprometa los datos personales bajo su custodia, el Procesador notificará al Controlador a través del correo electrónico registrado sin demora indebida tras tener conocimiento del incidente, proporcionando la información relevante sobre el mismo.
      </p>

      <h2 className="mt-4">5. ELIMINACIÓN DE DATOS</h2>
      <p>
        A la terminación del contrato de servicio, el Procesador permitirá al Controlador exportar sus datos. Transcurrido un periodo de gracia de sesenta (60) días tras la cancelación de la cuenta, el Procesador procederá a eliminar de forma segura de sus sistemas los datos personales gestionados, salvo que exista una obligación legal que exija su conservación.
      </p>
    </Container>
  );
};

export default DpaPage;